import { FC, SVGProps } from "react";
import { useMirrorTransform } from "src/i18n/direction";

const ExchangeIcon: FC<SVGProps<SVGSVGElement>> = ({ transform, ...props }) => {
  const mirroredTransform = useMirrorTransform(transform as string | undefined);
  return (
    <svg width="17" height="14" viewBox="0 0 17 14"  fill="currentcolor" transform={mirroredTransform} {...props}>
      <path
        d="M16.0665 9.40065L11.8998 13.5673C11.7781 13.689 11.6181 13.7506 11.4581 13.7506C11.2981 13.7506 11.1381 13.6898 11.0164 13.5673C10.7722 13.3232 10.7722 12.9273 11.0164 12.6831L14.1164 9.58315H3.12477C2.77977 9.58315 2.49977 9.30315 2.49977 8.95815C2.49977 8.61315 2.77977 8.33315 3.12477 8.33315H15.6248C15.8781 8.33315 16.1057 8.48556 16.2024 8.71889C16.299 8.95306 16.2456 9.22232 16.0665 9.40065ZM13.7498 4.7923C13.7498 4.4473 13.4698 4.1673 13.1248 4.1673H2.13397L5.23394 1.06732C5.47811 0.823154 5.47811 0.427292 5.23394 0.183125C4.98978 -0.0610417 4.59391 -0.0610417 4.34975 0.183125L0.18308 4.34979C0.00391353 4.52812 -0.0486581 4.7972 0.0471752 5.03054C0.143842 5.26387 0.372271 5.41648 0.624771 5.41648H13.1248C13.4698 5.41732 13.7498 5.1373 13.7498 4.7923Z"
      />
    </svg>
  );
};

export default ExchangeIcon;
